import React from 'react';
import * as S from './Short.styles';

interface ButtonProps {
  primary?: boolean;
  size?: 'small' | 'medium' | 'large';
  label: string;
  backgroundColor?: string;
  onClick?: () => void;
}

export const Button = ({
  primary = true,
  size = 'small',
  backgroundColor,
  label,
  ...props
}: ButtonProps) => {
  const mode = primary ? 'button-short--primary' : 'button-short--secondary';
  return (
    <S.Button
      type="button"
      className={['button-short', `button-short--${size}`, mode].join(' ')}
      style={{ backgroundColor }}
      {...props}
    >
      {label}
    </S.Button>
  );
};
